import { TRACK_CLICK_PRODUCT } from '~/redux/actions/types'

export const trackClickProduct = slug => {
  return {
    type: TRACK_CLICK_PRODUCT,
    slug
  }
}
